/**
 * routes/routes.tsx — react-router map.
 *
 * Phase 2 expands the route map from one page to ten plus three drill-ins.
 * Default landing is `/` (Overview). Bank Submission Status lives at the
 * same `/banks/submission-status` URL as Phase 1.
 *
 * Click-paths matrix:
 *   Overview                    /                                       (Overview)
 *   Loans                       /loans
 *   Deposits                    /deposits
 *   NPA Analysis                /npa
 *   Product Analytics           /products
 *   Product Detail              /products/:productCode?type=LOAN
 *   Branches                    /branches
 *   Branch Detail               /banks/:orgId/branches/:branchIdLocal
 *   Bank Detail                 /banks/:orgId
 *   Data Quality                /data-quality
 *   Bank Submission Status      /banks/submission-status                (Phase 1)
 */

import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import AppShell from '../layout/AppShell';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import LoginPage from '../pages/Login';
import OverviewPage from '../pages/Overview';
import BanksPage from '../pages/Banks';
import LoansPage from '../pages/Loans';
import DepositsPage from '../pages/Deposits';
import NPAAnalysisPage from '../pages/NPAAnalysis';
import ProductsPage from '../pages/Products';
import ProductDetailPage from '../pages/ProductDetail';
import BranchesPage from '../pages/Branches';
import BankDetailPage from '../pages/BankDetail';
import BranchDetailPage from '../pages/BranchDetail';
import DataQualityPage from '../pages/DataQuality';
import BankSubmissionStatusPage from '../pages/BankSubmissionStatus';
import NotFoundPage from '../pages/NotFound';

export const router = createBrowserRouter([
	{
		element: <PublicRoute />,
		children: [{ path: '/login', element: <LoginPage /> }],
	},
	{
		element: <ProtectedRoute />,
		children: [
			{
				element: <AppShell />,
				children: [
					{ path: '/', element: <OverviewPage /> },
					{ path: '/loans', element: <LoansPage /> },
					{ path: '/deposits', element: <DepositsPage /> },
					{ path: '/npa', element: <NPAAnalysisPage /> },
					{ path: '/products', element: <ProductsPage /> },
					{ path: '/products/:productCode', element: <ProductDetailPage /> },
					{ path: '/branches', element: <BranchesPage /> },
					{ path: '/data-quality', element: <DataQualityPage /> },
					// Banks: literal `/banks` (list), `/banks/submission-status` (specific
					// — must register BEFORE `:orgId`), then drill-ins.
					{ path: '/banks', element: <BanksPage /> },
					{
						path: '/banks/submission-status',
						element: <BankSubmissionStatusPage />,
					},
					{
						path: '/banks/:orgId/branches/:branchIdLocal',
						element: <BranchDetailPage />,
					},
					{ path: '/banks/:orgId', element: <BankDetailPage /> },
				],
			},
		],
	},
	{ path: '*', element: <NotFoundPage /> },
]);
